// snackbarSlice.js
import { createSlice } from "@reduxjs/toolkit";

export const snackbarSlice = createSlice({
	name: "snackbar",
	initialState: {
		open: false,
		message: "",
		severity: "success", // can be 'success', 'error', 'warning', 'info'
	},
	reducers: {
		showSnackbar: (state, action) => {
			state.open = true;
			state.message = action.payload.message;
			state.severity = action.payload.severity || "success";
		},
		closeSnackbar: (state) => {
			state.open = false;
		},
	},
});

export const { showSnackbar, closeSnackbar } = snackbarSlice.actions;

export default snackbarSlice.reducer;
